module.exports = __webpack_public_path__ + "img/Normal_MB_LWN.845ec87d.png";